import { FC } from 'react'

import { BreadcrumbProps } from '../../components/Breadcrumb'
import { MainLayoutProps } from '../../layouts'
import { BannerOfferProps } from '../../components/BannerOffer'
import { ProductBannerProps } from '../../components/ProductBanner'
import { DownloadFilesProps } from '../../components/DownloadFiles'
import { RetailerCardProps } from '../../components/RetailerCard'
import { MembersFeedbackProps } from '../../components/MembersFeedback'
import SectionWrapper from '../../components/SectionWrapper'
import BoxedContainer from '../../components/BoxedContainer'
import RichText from '../../components/RichText'
import { Icons } from '../../components/Icon'
import { useRichText } from '../../relay/RichText/useRichText'

import * as SC from './styled'

export type OfferTemplateProps = MainLayoutProps & {
  breadcrumb?: BreadcrumbProps
  productBanner: ProductBannerProps
  offerBanner?: BannerOfferProps
  offerDescription?: string | any[] | null
  downloadFile?: DownloadFilesProps
  retailerCard?: RetailerCardProps
  brandCard?: RetailerCardProps
  memberFeedback?: MembersFeedbackProps
}

const OfferTemplate: FC<OfferTemplateProps> = ({
  breadcrumb,
  productBanner,
  offerBanner,
  offerDescription,
  downloadFile,
  retailerCard,
  brandCard,
  memberFeedback,
  ...layout
}) => {
  const richTextProps = useRichText(offerDescription)

  return (
    <SC.Layout {...layout}>
      <SC.IconCrossesTop icon={Icons.crosses} width={100} />
      <BoxedContainer maxWidth={'Xsmall'}>
        {breadcrumb && <SC.BreadcrumbElement {...breadcrumb} />}
      </BoxedContainer>
      <SectionWrapper maxWidth={'Xsmall'}>
        <SC.BannerProduct {...productBanner} />
      </SectionWrapper>
      <SectionWrapper maxWidth={'Xsmall'} spacing={'small'}>
        {offerBanner && <SC.OfferBanner {...offerBanner} />}
      </SectionWrapper>
      <SectionWrapper maxWidth={'Xsmall'}>
        <SC.GridWrapper>
          <SC.DescriptionDownloadBlock>
            {offerDescription && (
              <SC.OfferDescription>
                <RichText {...richTextProps} />
              </SC.OfferDescription>
            )}
            {downloadFile && <SC.Download {...downloadFile} />}
          </SC.DescriptionDownloadBlock>
          <SC.CardContainer>
            {(brandCard || retailerCard) && (
              <SC.CardWrapper>
                {brandCard && <SC.Brand {...brandCard} />}
                {retailerCard && <SC.Retailer {...retailerCard} />}
              </SC.CardWrapper>
            )}
          </SC.CardContainer>
          {memberFeedback && <SC.Feedback {...memberFeedback} />}
        </SC.GridWrapper>
      </SectionWrapper>
      <SC.IconCrossesBottom icon={Icons.crosses} width={100} />
    </SC.Layout>
  )
}

export default OfferTemplate
